



















import { Component, Vue } from "vue-property-decorator";
import CourseForm from "@/components/courses/CourseForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import { CourseCreate as ICourseCreate } from "@/api-v2/course/models";
import CourseFormV2 from "@/components/courses/CourseV2/CourseFormV2.vue";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { courseApi } from "@/getinfo-api";
import { getCurrentCompanyId } from "@/plugins/roles";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({
  components: {
    CPageButtons,
    CourseFormV2,
    CField,
    CBlock,
    CPage,
    CBreadCrumbs,
    CourseForm
  }
})
export default class CourseCreateV2 extends Vue {
  form!: ICourseCreate;
  isLoading: boolean = false;
  data() {
    return {
      form: undefined
    };
  }

  courseCreate() {
    this.isLoading = true;
    courseApi.Course.createCourse(this.form)
      .then(res => {
        this.$router.push({ name: "course", params: { id: res.data.id } });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  decline() {
    this.$router.push({ name: "courses" });
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "courses" },
        label: this.$tc(this.$translate.Courses)
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }
}
